/**
 * Map ICAO hex code prefixes to ISO 3166-1 alpha-2 country codes
 * Based on ICAO 24-bit address allocation
 */

const icaoCountryRanges = [
  // Format: [startHex, endHex, countryCode]
  // Generated from the backend icao_country_range table (ICAO 24-bit address allocation);
  // nested ranges are listed first so the first match wins.
  [0x201000, 0x2013FF, 'na'], // Namibia
  [0x202000, 0x2023FF, 'er'], // Eritrea
  [0x501000, 0x5013FF, 'al'], // Albania
  [0x501C00, 0x501FFF, 'hr'], // Croatia
  [0x502C00, 0x502FFF, 'lv'], // Latvia
  [0x503C00, 0x503FFF, 'lt'], // Lithuania
  [0x504C00, 0x504FFF, 'md'], // Moldova
  [0x505C00, 0x505FFF, 'sk'], // Slovakia
  [0x506C00, 0x506FFF, 'si'], // Slovenia
  [0x507C00, 0x507FFF, 'uz'], // Uzbekistan
  [0x508000, 0x50FFFF, 'ua'], // Ukraine
  [0x510000, 0x5103FF, 'by'], // Belarus
  [0x511000, 0x5113FF, 'ee'], // Estonia
  [0x512000, 0x5123FF, 'mk'], // North Macedonia
  [0x513000, 0x5133FF, 'ba'], // Bosnia & Herzegovina
  [0x514000, 0x5143FF, 'ge'], // Georgia
  [0x515000, 0x5153FF, 'tj'], // Tajikistan
  [0x516000, 0x5163FF, 'me'], // Montenegro
  [0x600000, 0x6003FF, 'am'], // Armenia
  [0x600800, 0x600BFF, 'az'], // Azerbaijan
  [0x601000, 0x6013FF, 'kg'], // Kyrgyzstan
  [0x601800, 0x601BFF, 'tm'], // Turkmenistan
  [0x680000, 0x6803FF, 'bt'], // Bhutan
  [0x681000, 0x6813FF, 'fm'], // Micronesia
  [0x682000, 0x6823FF, 'mn'], // Mongolia
  [0x683000, 0x6833FF, 'kz'], // Kazakhstan
  [0x684000, 0x6843FF, 'pw'], // Palau
  [0x900000, 0x9003FF, 'mh'], // Marshall Islands
  [0x901000, 0x9013FF, 'ck'], // Cook Islands
  [0x902000, 0x9023FF, 'ws'], // Samoa
  [0x004000, 0x0043FF, 'zw'], // Zimbabwe
  [0x006000, 0x006FFF, 'mz'], // Mozambique
  [0x008000, 0x00FFFF, 'za'], // South Africa
  [0x010000, 0x017FFF, 'eg'], // Egypt
  [0x018000, 0x01FFFF, 'ly'], // Libya
  [0x020000, 0x027FFF, 'ma'], // Morocco
  [0x028000, 0x02FFFF, 'tn'], // Tunisia
  [0x030000, 0x0303FF, 'bw'], // Botswana
  [0x032000, 0x032FFF, 'bi'], // Burundi
  [0x034000, 0x034FFF, 'cm'], // Cameroon
  [0x035000, 0x0353FF, 'km'], // Comoros
  [0x036000, 0x036FFF, 'cg'], // Congo
  [0x038000, 0x038FFF, 'ci'], // Coate d Ivoire
  [0x03E000, 0x03EFFF, 'ga'], // Gabon
  [0x040000, 0x040FFF, 'et'], // Ethiopia
  [0x042000, 0x042FFF, 'gq'], // Equatorial Guinea
  [0x044000, 0x044FFF, 'gh'], // Ghana
  [0x046000, 0x046FFF, 'gn'], // Guinea
  [0x048000, 0x0483FF, 'gw'], // Guinea-Bissau
  [0x04A000, 0x04A3FF, 'ls'], // Lesotho
  [0x04C000, 0x04CFFF, 'ke'], // Kenya
  [0x050000, 0x050FFF, 'lr'], // Liberia
  [0x054000, 0x054FFF, 'mg'], // Madagascar
  [0x058000, 0x058FFF, 'mw'], // Malawi
  [0x05A000, 0x05A3FF, 'mv'], // Maldives
  [0x05C000, 0x05CFFF, 'ml'], // Mali
  [0x05E000, 0x05E3FF, 'mr'], // Mauritania
  [0x060000, 0x0603FF, 'mu'], // Mauritius
  [0x062000, 0x062FFF, 'ne'], // Niger
  [0x064000, 0x064FFF, 'ng'], // Nigeria
  [0x068000, 0x068FFF, 'ug'], // Uganda
  [0x06A000, 0x06A3FF, 'qa'], // Qatar
  [0x06C000, 0x06CFFF, 'cf'], // Central African Republic
  [0x06E000, 0x06EFFF, 'rw'], // Rwanda
  [0x070000, 0x070FFF, 'sn'], // Senegal
  [0x074000, 0x0743FF, 'sc'], // Seychelles
  [0x076000, 0x0763FF, 'sl'], // Sierra Leone
  [0x078000, 0x078FFF, 'so'], // Somalia
  [0x07A000, 0x07A3FF, 'sz'], // Swaziland
  [0x07C000, 0x07CFFF, 'sd'], // Sudan
  [0x080000, 0x080FFF, 'tz'], // Tanzania
  [0x084000, 0x084FFF, 'td'], // Chad
  [0x088000, 0x088FFF, 'tg'], // Togo
  [0x08A000, 0x08AFFF, 'zm'], // Zambia
  [0x08C000, 0x08CFFF, 'cd'], // D R Congo
  [0x090000, 0x090FFF, 'ao'], // Angola
  [0x094000, 0x0943FF, 'bj'], // Benin
  [0x096000, 0x0963FF, 'cv'], // Cape Verde
  [0x098000, 0x0983FF, 'dj'], // Djibouti
  [0x09A000, 0x09AFFF, 'gm'], // Gambia
  [0x09C000, 0x09CFFF, 'bf'], // Burkina Faso
  [0x09E000, 0x09E3FF, 'st'], // Sao Tome
  [0x0A0000, 0x0A7FFF, 'dz'], // Algeria
  [0x0A8000, 0x0A8FFF, 'bs'], // Bahamas
  [0x0AA000, 0x0AA3FF, 'bb'], // Barbados
  [0x0AB000, 0x0AB3FF, 'bz'], // Belize
  [0x0AC000, 0x0ACFFF, 'co'], // Colombia
  [0x0AE000, 0x0AEFFF, 'cr'], // Costa Rica
  [0x0B0000, 0x0B0FFF, 'cu'], // Cuba
  [0x0B2000, 0x0B2FFF, 'sv'], // El Salvador
  [0x0B4000, 0x0B4FFF, 'gt'], // Guatemala
  [0x0B6000, 0x0B6FFF, 'gy'], // Guyana
  [0x0B8000, 0x0B8FFF, 'ht'], // Haiti
  [0x0BA000, 0x0BAFFF, 'hn'], // Honduras
  [0x0BC000, 0x0BC3FF, 'vc'], // St.Vincent + Grenadines
  [0x0BE000, 0x0BEFFF, 'jm'], // Jamaica
  [0x0C0000, 0x0C0FFF, 'ni'], // Nicaragua
  [0x0C2000, 0x0C2FFF, 'pa'], // Panama
  [0x0C4000, 0x0C4FFF, 'do'], // Dominican Republic
  [0x0C6000, 0x0C6FFF, 'tt'], // Trinidad and Tobago
  [0x0C8000, 0x0C8FFF, 'sr'], // Suriname
  [0x0CA000, 0x0CA3FF, 'ag'], // Antigua & Barbuda
  [0x0CC000, 0x0CC3FF, 'gd'], // Grenada
  [0x0D0000, 0x0D7FFF, 'mx'], // Mexico
  [0x0D8000, 0x0DFFFF, 've'], // Venezuela
  [0x100000, 0x1FFFFF, 'ru'], // Russia
  [0x300000, 0x33FFFF, 'it'], // Italy
  [0x340000, 0x37FFFF, 'es'], // Spain
  [0x380000, 0x3BFFFF, 'fr'], // France
  [0x3C0000, 0x3FFFFF, 'de'], // Germany
  [0x400000, 0x43FFFF, 'gb'], // United Kingdom
  [0x440000, 0x447FFF, 'at'], // Austria
  [0x448000, 0x44FFFF, 'be'], // Belgium
  [0x450000, 0x457FFF, 'bg'], // Bulgaria
  [0x458000, 0x45FFFF, 'dk'], // Denmark
  [0x460000, 0x467FFF, 'fi'], // Finland
  [0x468000, 0x46FFFF, 'gr'], // Greece
  [0x470000, 0x477FFF, 'hu'], // Hungary
  [0x478000, 0x47FFFF, 'no'], // Norway
  [0x480000, 0x487FFF, 'nl'], // Netherlands
  [0x488000, 0x48FFFF, 'pl'], // Poland
  [0x490000, 0x497FFF, 'pt'], // Portugal
  [0x498000, 0x49FFFF, 'cz'], // Czech Republic
  [0x4A0000, 0x4A7FFF, 'ro'], // Romania
  [0x4A8000, 0x4AFFFF, 'se'], // Sweden
  [0x4B0000, 0x4B7FFF, 'ch'], // Switzerland
  [0x4B8000, 0x4BFFFF, 'tr'], // Turkey
  [0x4C0000, 0x4C7FFF, 'rs'], // Serbia (the former Yugoslavia block; ICAO reassigned it to Serbia)
  [0x4C8000, 0x4C83FF, 'cy'], // Cyprus
  [0x4CA000, 0x4CAFFF, 'ie'], // Ireland
  [0x4CC000, 0x4CCFFF, 'is'], // Iceland
  [0x4D0000, 0x4D03FF, 'lu'], // Luxembourg
  [0x4D2000, 0x4D23FF, 'mt'], // Malta
  [0x4D4000, 0x4D43FF, 'mc'], // Monaco
  [0x500000, 0x5003FF, 'sm'], // San Marino
  [0x700000, 0x700FFF, 'af'], // Afghanistan
  [0x702000, 0x702FFF, 'bd'], // Bangladesh
  [0x704000, 0x704FFF, 'mm'], // Myanmar
  [0x706000, 0x706FFF, 'kw'], // Kuwait
  [0x708000, 0x708FFF, 'la'], // Laos
  [0x70A000, 0x70AFFF, 'np'], // Nepal
  [0x70C000, 0x70C3FF, 'om'], // Oman
  [0x70E000, 0x70EFFF, 'kh'], // Cambodia
  [0x710000, 0x717FFF, 'sa'], // Saudi Arabia
  [0x718000, 0x71FFFF, 'kr'], // South Korea
  [0x720000, 0x727FFF, 'kp'], // North Korea
  [0x728000, 0x72FFFF, 'iq'], // Iraq
  [0x730000, 0x737FFF, 'ir'], // Iran
  [0x738000, 0x73FFFF, 'il'], // Israel
  [0x740000, 0x747FFF, 'jo'], // Jordan
  [0x748000, 0x74FFFF, 'lb'], // Lebanon
  [0x750000, 0x757FFF, 'my'], // Malaysia
  [0x758000, 0x75FFFF, 'ph'], // Philippines
  [0x760000, 0x767FFF, 'pk'], // Pakistan
  [0x768000, 0x76FFFF, 'sg'], // Singapore
  [0x770000, 0x777FFF, 'lk'], // Sri Lanka
  [0x778000, 0x77FFFF, 'sy'], // Syria
  [0x780000, 0x7BFFFF, 'cn'], // China
  [0x7C0000, 0x7FFFFF, 'au'], // Australia
  [0x800000, 0x83FFFF, 'in'], // India
  [0x840000, 0x87FFFF, 'jp'], // Japan
  [0x880000, 0x887FFF, 'th'], // Thailand
  [0x888000, 0x88FFFF, 'vn'], // Viet Nam
  [0x890000, 0x890FFF, 'ye'], // Yemen
  [0x894000, 0x894FFF, 'bh'], // Bahrain
  [0x895000, 0x8953FF, 'bn'], // Brunei
  [0x896000, 0x896FFF, 'ae'], // United Arab Emirates
  [0x897000, 0x8973FF, 'sb'], // Solomon Islands
  [0x898000, 0x898FFF, 'pg'], // Papua New Guinea
  [0x899000, 0x8993FF, 'tw'], // Taiwan (unofficial)
  [0x8A0000, 0x8A7FFF, 'id'], // Indonesia
  [0xA00000, 0xAFFFFF, 'us'], // United States
  [0xC00000, 0xC3FFFF, 'ca'], // Canada
  [0xC80000, 0xC87FFF, 'nz'], // New Zealand
  [0xC88000, 0xC88FFF, 'fj'], // Fiji
  [0xC8A000, 0xC8A3FF, 'nr'], // Nauru
  [0xC8C000, 0xC8C3FF, 'lc'], // Saint Lucia
  [0xC8D000, 0xC8D3FF, 'to'], // Tonga
  [0xC8E000, 0xC8E3FF, 'ki'], // Kiribati
  [0xC90000, 0xC903FF, 'vu'], // Vanuatu
  [0xE00000, 0xE3FFFF, 'ar'], // Argentina
  [0xE40000, 0xE7FFFF, 'br'], // Brazil
  [0xE80000, 0xE80FFF, 'cl'], // Chile
  [0xE84000, 0xE84FFF, 'ec'], // Ecuador
  [0xE88000, 0xE88FFF, 'py'], // Paraguay
  [0xE8C000, 0xE8CFFF, 'pe'], // Peru
  [0xE90000, 0xE90FFF, 'uy'], // Uruguay
  [0xE94000, 0xE94FFF, 'bo'], // Bolivia
];

/**
 * Get country code from ICAO hex code
 * @param {string} hex - ICAO hex code (e.g., '3C6481')
 * @returns {string|null} - Two-letter country code or null if not found
 */
export function getCountryFromHex(hex) {
  if (!hex) return null;

  // Remove any non-hex characters and convert to uppercase
  const cleanHex = hex.replace(/[^0-9A-Fa-f]/g, '').toUpperCase();

  // Convert to decimal
  const hexValue = parseInt(cleanHex, 16);

  if (isNaN(hexValue)) return null;

  // Find matching country range
  for (const [start, end, countryCode] of icaoCountryRanges) {
    if (hexValue >= start && hexValue <= end) {
      return countryCode;
    }
  }

  return null;
}

/**
 * Check if aircraft is military based on category
 * @param {string} category - Aircraft category (A0-A7 = civilian, B/C = military/government)
 * @returns {boolean}
 */
export function isMilitaryAircraft(category) {
  // If no category, assume NOT military (require positive identification)
  if (!category) return false;

  // Only categories explicitly starting with B or C are military/government
  // B = Surface vehicles (often military), C = Ground obstruction/military
  // Don't assume unknown categories are military
  return /^[BC]/.test(category);
}

/**
 * ISO 3166-1 alpha-2 country of a live-map aircraft, lowercase, for the flag
 * sprite (`flag-xx`) and the roundel cache. Prefers the backend's fields and
 * falls back to the hex allocation. Never returns a country *name*.
 * @param {{dbFlags_country?:string, country_code?:string, hex?:string}} aircraft
 * @returns {string|null}
 */
export function aircraftCountryCode(aircraft) {
  if (!aircraft) return null;
  const code = aircraft.dbFlags_country || aircraft.country_code || getCountryFromHex(aircraft.hex);
  if (!code || typeof code !== 'string' || code.length !== 2) return null;
  return code.toLowerCase();
}
